import { QuizType } from "@/components/quiz/QuizComponent";

export class Quiz {
    date: Date;
    type: QuizType;
    route: string;
    answers: any;
    location?: string;
}